<template>
  <div id="alt-footer-menu-desktop" v-if="menus">
    <div class="footer-row">
      <section class="footer-col" v-for="(menu, menu_id) in menus" :key="menu_id">
        <h2 class="footer-col-title" @click="footerToggleMenu($event, `footer-menu-${menu_id}`)">{{ menu.title }}<svg class="cs_none" xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 32 32">
          <path fill="currentColor" stroke="currentColor" stroke-width="4" d="m4.22 10.78l-1.44 1.44l12.5 12.5l.72.686l.72-.687l12.5-12.5l-1.44-1.44L16 22.564z"/>
        </svg>
        </h2>
        <div class="menu-footer-our-company-container footer-col-container">
          <ul :id="`footer-menu-${menu_id}`" class="agp-light fs-13px" @click="clickCloseToggle($event)">
            <li class="menu-item" v-for="item in menu.items" :key="item.id">
              <a :href="getLangUrl(item.url, baseUrl, locale)">{{ htmlSpecialcharsDecode(item.title) }}</a>
            </li>
          </ul>
        </div>
      </section>

      <section class="footer-col">
        <h2 class="footer-col-title" @click="footerToggleMenu($event, 'footer-contact-us')">{{ footerInfo.title }} <svg class="cs_none" xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 32 32">
          <path fill="currentColor" stroke="currentColor" stroke-width="4" d="m4.22 10.78l-1.44 1.44l12.5 12.5l.72.686l.72-.687l12.5-12.5l-1.44-1.44L16 22.564z"/>
        </svg></h2>

        <div id="footer-contact-us" class="footer-col-container">

          <p class="alt-contact-hightlight" v-if="companyInfo.company_name">
            {{ companyInfo.company_name }}
          </p>

          <p class="alt-contact-hightlight" @click="clickCloseToggle($event)">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24"><path fill="#88888d" d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2zm-2 0l-8 4.99L4 6zm0 12H4V8l8 5l8-5z"/></svg>
            <a rel="nofollow" :href="`mailto:${footerInfo.info.email}`">{{ footerInfo.info.email }}</a>
          </p>
          <!-- Phone -->
          <!-- <p class="alt-contact-hightlight" @click="clickCloseToggle($event)">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24"><path fill="#88888d" d="m19.23 15.26l-2.54-.29a1.99 1.99 0 0 0-1.64.57l-1.84 1.84a15.05 15.05 0 0 1-6.59-6.59l1.85-1.85c.43-.43.64-1.03.57-1.64l-.29-2.52a2 2 0 0 0-1.99-1.77H5.03c-1.13 0-2.07.94-2 2.07c.53 8.54 7.36 15.36 15.89 15.89c1.13.07 2.07-.87 2.07-2v-1.73c.01-1.01-.75-1.86-1.76-1.98"/></svg>
            <a rel="nofollow" :href="footerInfo.info.phone.link">{{ footerInfo.info.phone.text }}</a>
          </p> -->
          <p class="alt-contact-hightlight" @click="clickCloseToggle($event)">
            <img src="/listing/chat.svg" class="icon_chat" alt="chat">
            <a href="https://api.whatsapp.com/send?phone=60122394033&text=Hi%2C+I+would+like+to+enquire+about+your+services&type=phone_number" class="chat_link" id="kts-faq-chatlink" >WhatsApp</a>
          </p>
          <p class="alt-contact-hightlight" v-if="companyInfo.company_address" v-html="companyInfo.company_address">
          </p>
          <div class="footer-operating-hours" v-html="footerInfo.info.operating_hours"></div>
        </div>

        <div class="social-media social-media__desktop">
          <a rel="nofollow noreferrer" aria-label="Facebook" class="footer-share footer-facebook" target="_blank" :href="footerInfo.social.facebook" v-if="footerInfo.social.facebook"></a>
          <a rel="nofollow noreferrer" aria-label="TikTok" class="footer-share footer-tiktok" target="_blank" :href="footerInfo.social.tiktok" v-if="footerInfo.social.tiktok"></a>
          <a rel="nofollow noreferrer" aria-label="YouTube" class="footer-share footer-youtube" target="_blank" :href="footerInfo.social.youtube" v-if="footerInfo.social.youtube"></a>
          <a rel="nofollow noreferrer" aria-label="Instagram" class="footer-share footer-instagram" target="_blank" :href="footerInfo.social.instagram" v-if="footerInfo.social.instagram"></a>
        </div>
      </section>
    </div>
    <div class="social-media social-media__mobile">
      <a rel="nofollow noreferrer" aria-label="Facebook" class="footer-share footer-facebook" target="_blank" :href="footerInfo.social.facebook" v-if="footerInfo.social.facebook" ></a>
      <a rel="nofollow noreferrer" aria-label="TikTok" class="footer-share footer-tiktok" target="_blank" :href="footerInfo.social.tiktok" v-if="footerInfo.social.tiktok"></a>
      <a href="https://www.skjewellery.com.my" aria-label="SK Jewellery" class="footer-custom-logo-link"><img width="35" height="30" class="footer-custom-logo" src="https://www.skjewellery.com.my/api/wp-content/uploads/nuxt/skj-logo-new.webp" alt="SK Jewellery Logo"></a>
      <a rel="nofollow noreferrer" aria-label="Instagram" class="footer-share footer-instagram" target="_blank" :href="footerInfo.social.instagram" v-if="footerInfo.social.instagram"></a>
      <a rel="nofollow noreferrer" aria-label="YouTube" class="footer-share footer-youtube" target="_blank" :href="footerInfo.social.youtube" v-if="footerInfo.social.youtube"></a>
    </div>
    <section class="footer-copyright">
      <p>{{ copyright }}</p>
      <p v-if="companyInfo.company_extra_info">{{ companyInfo.company_extra_info }}</p>
    </section>
    <div id="oa-live-support-widget" v-if="liveSupport">
      <div class="oa-live-support">
        <div class="oa-live-support__popup">
          <div class="oa-live-support__heading oa-live-support__animation--fade-in">
            <h4>{{ liveSupport.main_title }}</h4>
            <div class="oa-live-support__close-widget">
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="15" height="15" rx="7.5" fill="#9D9D9D" />
                <path d="M11.875 4.00625L10.9938 3.125L7.5 6.61875L4.00625 3.125L3.125 4.00625L6.61875 7.5L3.125 10.9938L4.00625 11.875L7.5 8.38125L10.9938 11.875L11.875 10.9938L8.38125 7.5L11.875 4.00625Z" fill="white" />
              </svg>
            </div>
          </div>
          <div class="oa-live-support__body">
            <div class="oa-live-support__services">
                <a
                  v-for="(service, key) in liveSupport.data"
                  :key="key"
                  :class="`oa-live-support__service oa-live-support__animation--fade-in oa-live-support__service--${key}`"
                  :href="getServiceLink(key.toString())"
                  target="_blank"
                >
                  <img v-if="getServiceIcon(key.toString())" :src="getServiceIcon(key.toString())" alt="">
                  <span>{{ getServiceTitle(key.toString()) }}</span>
              </a>
            </div>
          </div>
          <div class="oa-live-support__footer"></div>
        </div>
        <div class="oa-live-support__icon">
          <svg color="inherit" viewBox="0 0 32 32" class="oa-live-support__icon-default">
            <path
              fill="#FFFFFF"
              d="M12.63,26.46H8.83a6.61,6.61,0,0,1-6.65-6.07,89.05,89.05,0,0,1,0-11.2A6.5,6.5,0,0,1,8.23,3.25a121.62,121.62,0,0,1,15.51,0A6.51,6.51,0,0,1,29.8,9.19a77.53,77.53,0,0,1,0,11.2,6.61,6.61,0,0,1-6.66,6.07H19.48L12.63,31V26.46"
            ></path>
            <path
              fill="#AD073D"
              d="M19.57,21.68h3.67a2.08,2.08,0,0,0,2.11-1.81,89.86,89.86,0,0,0,0-10.38,1.9,1.9,0,0,0-1.84-1.74,113.15,113.15,0,0,0-15,0A1.9,1.9,0,0,0,6.71,9.49a74.92,74.92,0,0,0-.06,10.38,2,2,0,0,0,2.1,1.81h3.81V26.5Z"
              class="css-1arh9bj eam5rsy0"
            ></path>
          </svg>
          <div class="oa-live-support__icon-dotted">
            <svg color="inherit" viewBox="0 0 32 32" class="oa-live-support__icon-hover">
              <path
                fill="#FFFFFF"
                d="M12.63,26.46H8.83a6.61,6.61,0,0,1-6.65-6.07,89.05,89.05,0,0,1,0-11.2A6.5,6.5,0,0,1,8.23,3.25a121.62,121.62,0,0,1,15.51,0A6.51,6.51,0,0,1,29.8,9.19a77.53,77.53,0,0,1,0,11.2,6.61,6.61,0,0,1-6.66,6.07H19.48L12.63,31V26.46"
              ></path>
              <path
                fill="#FFFFFF"
                d="M19.57,21.68h3.67a2.08,2.08,0,0,0,2.11-1.81,89.86,89.86,0,0,0,0-10.38,1.9,1.9,0,0,0-1.84-1.74,113.15,113.15,0,0,0-15,0A1.9,1.9,0,0,0,6.71,9.49a74.92,74.92,0,0,0-.06,10.38,2,2,0,0,0,2.1,1.81h3.81V26.5Z"
                class="css-y16l9e eam5rsy0"
              ></path>
            </svg>
            <svg viewBox="0 0 60 40" width="18px" fill="#AD073D" class="oa-live-support__icon-hover">
              <circle r="6" cy="20" cx="9" class="oa-live-support__icon-animation"></circle>
              <circle r="6" cy="20" cx="30" class="oa-live-support__icon-animation"></circle>
              <circle r="6" cy="20" cx="51" class="oa-live-support__icon-animation"></circle>
            </svg>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<style lang="scss">
  @import "@/assets/scss/partials/_live-support.scss";
</style>
<script lang="ts" setup>
import CustomLink from '~/components/CustomLink.vue';
import { oaInitLiveSupport, initLiveChat, initLiveChatClick, initCloseWidget } from '~/assist/LiveSupport';
const { $file } = useNuxtApp();
const userStore = useUserStore();
const runtimeConfig = useRuntimeConfig();
const menus = ref();
const footerInfo = ref();
const liveSupport = ref();
const companyInfo = ref();
const copyright = ref<string>('');
const route = useRoute();
const currentPath = computed(() => route.path);
import { useI18n } from 'vue-i18n';
const { locale } = useI18n();
import { getLangUrl } from '~/utils/getLangUrl';
const baseUrl = runtimeConfig.public.BASE_URL;

const footerToggleMenu = (event: Event, id: string = '') => {
    event.preventDefault();
    const screenWidth = window.innerWidth;
    if (screenWidth >= 1000) {
      return
    }
    if( id ) {
      const elements = document.querySelectorAll('.footer-col.toggle-open .footer-col-container > ul');
      const currentElement = document.getElementById(id);
      const filteredElements = Array.from(elements).filter(element => element !== currentElement);
      document.querySelectorAll('#alt-footer-menu-desktop .footer-col').forEach(el => {
          el.classList.remove('toggle-open');
      });
      if( typeof filteredElements[0] != 'undefined' ) {
        filteredElements[0].classList.remove('toggle-open');
        slideUp(filteredElements[0], 500);
      }

      slideToggle(currentElement, 500, '.footer-col');
    }
}
const livesupportPosition = () => {
  const liveSupportWidget = document.querySelector('#oa-live-support-widget .oa-live-support');
  const isProduct = document.querySelector('#product');
  if (liveSupportWidget) {
      if(isProduct!==null) {
          liveSupportWidget.classList.add('spd');
      }else{
          liveSupportWidget.classList.remove('spd');
      }
  }
}
const clickCloseToggle = (event) => {
  const screenWidth = window.innerWidth;
  if (screenWidth >= 1000) {
    return;
  }

  event.preventDefault();

  document.querySelectorAll('#alt-footer-menu-desktop .footer-col').forEach(el => {
    el.classList.remove('toggle-open');
  });

  const footerCompany = document.querySelector('#footer-contact-us');
  const footerCompanyItems = document.querySelectorAll('.footer-col-container .agp-light');

  if (footerCompany) footerCompany.style.display = 'none';
  if (footerCompanyItems.length > 0) {
    footerCompanyItems.forEach(item => item.style.display = 'none');
  }

  const aTag = (event.target as HTMLElement).closest('a');
  if (aTag && aTag.href) {
    window.location.href = aTag.href;  // OPEN MAILTO
  }
};

const firstLoad = ref(false);
onMounted(() => {
  livesupportPosition();
  window.addEventListener('mousemove', (e) => {
    if ( firstLoad.value == false){
      //initLiveChat();
      oaInitLiveSupport();
      initLiveChatClick();
      initCloseWidget();
      firstLoad.value = true;
    }
  });
  if (window.innerWidth < 700) {
    window.addEventListener('touchstart', (e) => {
      if ( firstLoad.value == false){
        //initLiveChat();
        oaInitLiveSupport();
        initLiveChatClick();
        initCloseWidget();
        firstLoad.value = true;
      }
    });
  }
});
watch(
  currentPath,
  () => {
    livesupportPosition();
  }
);

watch(
  () => route.path,
  async () => {
    await nextTick(); // Wait for DOM updates
    livesupportPosition();
  }
);
interface MenuItem {
  id: number;
  title: string;
  url: string;
  classes: string;
}

interface Menu {
  title: string;
  items: MenuItem[];
}

interface ContactInfo {
  email: string;
  phone: {
    link: string;
    text: string;
  };
  livechat: string;
  operating_hours: string;
}

interface SocialLinks {
  facebook: string;
  tiktok: string;
  youtube: string;
  instagram: string;
}

interface ContactUs {
  title: string;
  info: ContactInfo;
  social: SocialLinks;
}

interface FooterMenus {
  [key: string]: Menu;
}
interface ILiveSupport{
  main_title: string,
  main_icon: string,
  services: {
    value: string,
    label: string
  }[],
  data: {
    livechat: {
      livechat_icon: Record<string, any>;
    };
    whatsapp: {
      whatsapp_icon: Record<string, any>;
      whatsapp_phone: string;
    };
    appointment: {
      appointment_icon: Record<string, any>;
      appointment_link: string;
    };
  };

}

interface ExtraInfo {
  company_name: string;
  company_address: ContactInfo;
  company_extra_info: SocialLinks;
}

interface IFooterMenuResponse {
  menus: FooterMenus;
  contact_us: ContactUs;
  copyright: string;
  live_support: ILiveSupport;
  skmy_company?: ExtraInfo;
}

const getData = async () => {
  try {
    const { data, error } = await useAsyncData(
      'footerMenu',
      async () => {
        return await $file.get('menu/footer-menu.json', {
        headers: {
          Authorization: `Bearer ${userStore.csrf}`,
          'X-API-Server': userStore.csrf_server
        },
      });
      }
    );

    const response = data.value as IFooterMenuResponse;

    menus.value = response.menus;
    copyright.value = response.copyright;
    footerInfo.value = response.contact_us;
    liveSupport.value = response.live_support;
    companyInfo.value = response.skmy_company;
  } catch (err: any) {
    //console.log('err.response', err);
  }
}
const getServiceLink = (key: string) => {
  switch (key) {
    case 'whatsapp':
      return liveSupport.value.data[key]?.whatsapp_phone ? `https://wa.me/${liveSupport.value.data[key].whatsapp_phone}` : '#';
    case 'appointment':
      return liveSupport.value.data[key]?.appointment_link || '#';
    case 'livechat':
      return '#';
    default:
      return '#';
  }
};
const getServiceTitle = (key: string) => {
  const service = liveSupport.value.services.find((service: { value: string, label: string }) => service.value === key);
  return service ? service.label : '';
};

const getServiceIcon = (key: string) => {
  switch (key) {
    case 'whatsapp':
      return liveSupport.value.data[key].whatsapp_icon?.url || '';
    case 'appointment':
      return liveSupport.value.data[key].appointment_icon?.url || '';
    case 'livechat':
      return liveSupport.value.data[key].livechat_icon?.url || '';
    default:
      return '';
  }

};

getData();
</script>